import { MoreOutlined } from "@ant-design/icons";
import TableUi from "../../../../../../atoms/StaticTable";
import taskTable from "../DummyData/taskTable.json";

import { Button, Image, TableColumnsType, Tag } from "antd";
import Dropdown from "antd/es/dropdown/dropdown";
import CancelIcon from "../../../../../../atoms/CustomIcons/CancelIcon";
import ConfirmIcon from "../../../../../../atoms/CustomIcons/ConfirmIcon";
import { useRef, useState } from "react";
import Filters from "./Filters";

export default function TabTasks() {
  const location = window.location.pathname;
  const pathSegments = location.split("/");

  const companyId = pathSegments[pathSegments.length - 1];
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const dropdownRef = useRef<HTMLButtonElement>(null);

  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);
  const [archived, isArchived] = useState(false);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string;
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const items = [
    {
      key: "1",
      label: (
        <Button type="text" icon={<ConfirmIcon />}>
          Change status to...
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button type="text" icon={<CancelIcon />}>
          Cancel work order
        </Button>
      ),
    },
  ];

  const statusClassMap: Record<string, string> = {
    scheduled: "approval_pending_tag",
    open: "grey_tag",
  };

  const serviceLineClassMap: Record<string, string> = {
    "landscape maintenance": "green_tag",
    landscape: "green_tag",
    irrigation: "violet_tag",
    construction: "yellow_tag",
  };

  const columns: TableColumnsType = [
    {
      title: "Tasks",
      dataIndex: "name",
      width: 320,
      render: (text) => text ?? "-",
      fixed: "left",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 147,
      render: (text) => {
        const cls = statusClassMap[text?.toLowerCase()] || "default_tag";
        return (
          <Tag
            className={cls}
            style={{ textTransform: "capitalize", border: 0 }}
          >
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Priority",
      dataIndex: "priority",
      width: 140,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Due date",
      dataIndex: "due_date",
      width: 170,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Occurrence",
      dataIndex: "occurrence",
      width: 140,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Scheduled date",
      dataIndex: "schedule_date",
      width: 195,
      render: (text) => (text ? text : "-"),
    },
    {
      title: "Service line",
      dataIndex: "service_line",
      width: 270,
      render: (text) => {
        const cls = serviceLineClassMap[text?.toLowerCase()] || "default_tag";
        return text ? <Tag className={cls}>{text}</Tag> : "-";
      },
      sorter: (a, b) => a?.service_line?.localeCompare(b?.service_line),
    },
    {
      title: "Service",
      dataIndex: "service",
      width: 270,
      render: (text) => (text ? text : "-"),
    },

    {
      title: "Date completed",
      dataIndex: "date_completed",
      width: 170,
      render: (text) => text ?? "-",
    },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items:
              record?.status === "active"
                ? items
                : items.filter(
                    (item) => item?.key !== "1" && item?.key !== "1"
                  ),
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              console.log("text", record);
              // setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  return (
    <div className="dashboard-tab">
      <TableUi
        columns={columns}
        data={{
          count: taskTable?.length,
          data: taskTable || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
            companyId={companyId}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        // onClickRow={onClickRow}
      />
    </div>
  );
}
